import { warehouseClient } from "@/infrastructure/http/warehouseClient";
import type { InventoryStockListResponse, InventoryStockSummary, ApiEnvelope } from "@/domain/types";

export async function listInventoryStock(params: {
  page?: number;
  limit?: number;
  warehouseId?: string;
  locationId?: string;
  productId?: string;
  search?: string;
  categoryId?: string;
}): Promise<InventoryStockListResponse> {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.warehouseId) query.set("warehouseId", params.warehouseId);
  if (params.locationId) query.set("locationId", params.locationId);
  if (params.productId) query.set("productId", params.productId);
  if (params.search) query.set("search", params.search);
  if (params.categoryId) query.set("categoryId", params.categoryId);
  const response = await warehouseClient.get<ApiEnvelope<InventoryStockListResponse>>(`/inventory-stock?${query.toString()}`);
  return response.data.data;
}

export async function getStockSummary(warehouseId: string): Promise<InventoryStockSummary[]> {
  const response = await warehouseClient.get<ApiEnvelope<InventoryStockSummary[]>>(`/inventory-stock/summary?warehouseId=${warehouseId}`);
  return response.data.data ?? [];
}
export interface AvailableLotsResponse {
  lots: string[];
  hasDefault: boolean;
}

export async function getAvailableLots(productId: string, locationId: string): Promise<AvailableLotsResponse> {
  const response = await warehouseClient.get<ApiEnvelope<AvailableLotsResponse>>(`/inventory-stock/lots?productId=${productId}&locationId=${locationId}`);
  return response.data.data ?? { lots: [], hasDefault: false };
}
